<template>
  <div class="border-top p-3">
    <div class="eyebrow-label mb-3">
      {{ $t("bulk_buy.shared_cancellation_settings") }}
    </div>
    <div class="row g-3">
      <div class="col-md-2">
        <label class="form-label">
          {{ $t("bulk_buy.beneficiary_type") }}
          <span class="text-danger">*</span>
        </label>
        <select
          v-model="model.beneficiary_type"
          class="form-select form-select-sm"
        >
          <option
            v-for="type in allowedBeneficiaryTypes"
            :key="type"
            :value="type"
          >
            {{ $t(`bulk_buy.beneficiary_types.${type}`) }}
          </option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label">
          {{ $t("bulk_buy.period_start") }}
          <span class="text-danger">*</span>
        </label>
        <input
          v-model="model.period_start"
          type="date"
          class="form-control form-control-sm"
        />
      </div>
      <div class="col-md-3">
        <label class="form-label">
          {{ $t("bulk_buy.period_end") }}
          <span class="text-danger">*</span>
        </label>
        <input
          v-model="model.period_end"
          type="date"
          :min="model.period_start || undefined"
          class="form-control form-control-sm"
        />
      </div>
      <div class="col-md-4">
        <label class="form-label">
          {{ $t("bulk_buy.cancellation_purpose_text") }}
          <span class="text-danger">*</span>
        </label>
        <input
          v-model="model.operation_notes"
          type="text"
          class="form-control form-control-sm"
          :placeholder="operationNotesPlaceholder"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import type { GlobalCancellationSettings } from "./bulkBuyTypes";
import { BeneficiaryType, defaultOperationNotes } from "./bulkBuyTypes";

const model = defineModel<GlobalCancellationSettings>({ required: true });

const { t } = useI18n();

const allowedBeneficiaryTypes = [
  BeneficiaryType.CONSUMER,
  BeneficiaryType.ELECTRICITY_SELLER,
];

const operationNotesPlaceholder = computed(() =>
  model.value.beneficiary_type === BeneficiaryType.CONSUMER
    ? t("bulk_buy.operation_notes_placeholder_consumer")
    : t("bulk_buy.operation_notes_placeholder_seller")
);

// NOTE: swap in the new type's default purpose only while the user hasn't customised the text.
watch(
  () => model.value.beneficiary_type,
  (newType, oldType) => {
    const current = model.value.operation_notes.trim();
    if (!current || (oldType && current === defaultOperationNotes(oldType))) {
      model.value.operation_notes = defaultOperationNotes(newType);
    }
  }
);
</script>
